import { Link } from "react-router-dom";
import { specials } from "@/mocks/specials";
import SectionHeading from "@/components/feature/SectionHeading";

export default function SpecialPreview() {
  const [featured, ...others] = specials;

  return (
    <section className="border-y border-background-200/50 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="Editorial Features"
          title="影评专题精选"
          description="由编辑团队策划的深度专题，围绕热门影片展开多角度解读，帮你看懂电影背后的表达。"
          moreTo="/special"
          moreLabel="进入专题"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-5">
          <Link
            to="/special"
            className="group relative overflow-hidden rounded-lg border border-background-200/60 lg:col-span-3"
          >
            <div className="relative h-64 w-full overflow-hidden md:h-80">
              <img
                src={featured.cover}
                alt={featured.title}
                title={`${featured.title} - 黄色大片 影评专题`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/55 to-transparent" />
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7">
              <span className="rounded-full bg-accent-500 px-3 py-1 font-label text-xs uppercase tracking-widest text-foreground-950">
                本期主打
              </span>
              <h3 className="mt-3 font-heading text-xl font-bold text-foreground-50 md:text-2xl">
                {featured.title}
              </h3>
              <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-200">{featured.intro}</p>
              <div className="mt-4 flex items-center gap-2 text-xs text-primary-400">
                <i className="ri-arrow-right-circle-line text-base" />
                共 {featured.articles.length} 篇影评
              </div>
            </div>
          </Link>

          <div className="flex flex-col gap-4 lg:col-span-2">
            {others.map((special) => (
              <div
                key={special.id}
                className="flex flex-1 flex-col rounded-lg border border-background-200/60 bg-background-50 p-5"
              >
                <h3 className="font-heading text-base font-bold text-foreground-50">
                  <Link to="/special" className="transition-colors hover:text-primary-400">
                    {special.title}
                  </Link>
                </h3>
                <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-400">{special.intro}</p>
                <ul className="mt-3 space-y-2">
                  {special.articles.slice(0, 2).map((article) => (
                    <li key={article.id}>
                      <Link
                        to={`/detail/${article.movieId}`}
                        className="group flex items-start gap-2 text-xs text-foreground-300 transition-colors hover:text-primary-400"
                      >
                        <i className="ri-article-line mt-0.5 flex-shrink-0 text-sm text-primary-400" />
                        <span className="line-clamp-2 leading-relaxed">{article.title}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}